import React, { Suspense, lazy } from 'react';
import { Route, Router, Switch, withRouter, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import compose from 'lodash/flowRight';
import App from './App';
import history from './history';
import PropTypes from 'prop-types';
import { AppStore } from './stores/App.store';
import LanguageService from './services/Language.service';

const ProptechLandingPage = withRouter(
  lazy(() => import('./landings/proptech'))
);

const RootApp = ({ appStore: { currentLanguage } }) => (
  <Router history={history} key={currentLanguage}>
    <Suspense fallback={<div>Loading</div>}>
      <Switch>
        <Route path={`/${currentLanguage}/`} component={App} />
        <Route
          render={({ location }) => (
            <Redirect
              to={{
                pathname: LanguageService.createLink(
                  currentLanguage,
                  location.pathname,
                ),
                search: location.search,
                state: location.state,
              }}
            />
          )}
        />
      </Switch>
    </Suspense>
  </Router>
);

RootApp.propTypes = {
  appStore: PropTypes.instanceOf(AppStore).isRequired,
};

export default compose(
  inject('appStore'),
  observer
)(RootApp);



// WEBPACK FOOTER //
// ./src/RootApp.jsx